import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { withText } = {}) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1.25),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      columnGap: theme.spacing(1),
      marginTop: 0,
    },
  },
  text: {
    color: theme.palette.darkGrey,
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
  },
  imageContainer: {
    height: 24,
    width: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.lightGrey,
    borderRadius: 4,
    [theme.breakpoints.down('md')]: {
      height: withText ? 24 : 20,
      width: withText ? 24 : 20,
    },
  },
  image: {
    height: 16,
    width: 16,
    [theme.breakpoints.down('md')]: {
      height: withText ? 16 : 14,
      width: withText ? 16 : 14,
    },
  },
  tooltip: {
    color: theme.palette.darkGrey,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '20px',
    marginTop: '10px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      lineHeight: '18px',
    },
  },
  arrow: {
    color: '#FFFFFF',
  },
}));
